import moment from 'moment';

import { DiscrepancyReportEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';

export const PrintTypeEnum = {
  OrderedVsReceived: 0,
  OnHandVsPhysical: 1,
};

export const INITIAL_VALUES = {
  [DiscrepancyReportEnum.Site]: GenericEnum.ZeroString,
  [DiscrepancyReportEnum.Vendor]: 0,
  [DiscrepancyReportEnum.Type]: PrintTypeEnum.OrderedVsReceived,
  [DiscrepancyReportEnum.DateFrom]: moment()
    .subtract(1, 'month')
    .format(DATE_FORMAT_FOR_UI),
  [DiscrepancyReportEnum.DateTo]: moment()
    .add(1, 'month')
    .format(DATE_FORMAT_FOR_UI),
  [DiscrepancyReportEnum.OnHandDateTo]: moment(moment().endOf('month')).format(
    DATE_FORMAT_FOR_UI
  ),
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/discrepancyreport/helper/index.js